import { Icon56ErrorTriangleOutline } from '@vkontakte/icons';
import { Button, Spacing, Title } from '@vkontakte/vkui';
import React from 'react';

import styles from './WorkspaceSuperappErrorPage.css';

export const WorkspaceSuperappErrorPage = () => {
    const handleClick = () => {
        window.location.reload();
    };

    return (
        <div className={styles.wrapper}>
            <Icon56ErrorTriangleOutline className={styles.icon} />
            <Title>Ошибка загрузки</Title>
            <Spacing size={24} />
            <Button mode="link" onClick={handleClick}>
                Обновить страницу
            </Button>
        </div>
    );
};
